<template>
  <v-autocomplete
    :items="items"
    v-model="selected"
    :label="label"
    :error-messages="error"
    :disabled="disabled"
    item-value="id"
    item-text="username"
    :search-input.sync="search"
  ></v-autocomplete>
</template>
<script>
export default {
  name: 'admin-input',
  data () {
    return {
      search: null,
      items: []
    }
  },
  created () {
    this.fetch()
  },
  watch: {
    value () {
      if (!this.value) this.search = ''
      this.fetch()
    },
    search () {
      if (!this.search) this.$emit('input', null)
      else this.fetch()
    }
  },
  methods: {
    async fetch () {
      let query
      if (this.search) {
        query = [
          { where: ['username', 'like', `%${this.search}%`] }
        ]
      } else if (this.value) {
        query = [
          { where: ['id', this.value] }
        ]
      }
      let users = await this.$apiAjax.getData('/user', {
        params: {
          query: query && JSON.stringify(query),
          type: this.role
        }
      })
      this.items = users
    }
  },
  computed: {
    selected: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  props: {
    value: [String, Object, Number],
    label: String,
    role: {
      type: String,
      default: 'all'
    },
    disabled: Boolean,
    error: String
  }
}
</script>
<style lang="scss" scoped>
</style>
